export default __webpack_public_path__ + "static/media/Introduction_Official.0c9d9baf.mp4";